/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, Heading, Image, useDisclosure, VStack } from '@chakra-ui/react';
import { useCallback, useEffect } from 'react';
import { InlineWidget } from 'react-calendly';
import { MainTemplate } from '../../templates/MainTemplate';
import { TelemedicineAcceptModal } from './TelemedicineAcceptModal';
import { Text } from '../../components/atoms/Text';
import { SelectInput } from '../../components/atoms/Input';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTheme } from '../../contexts/ThemeProvider';
import { FaFrown } from 'react-icons/fa';
import { Label } from '../../components/atoms/Label';

export function TelemedicineSchedulePage() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { colors } = useTheme();

  const formSchema = z.object({
    specialist: z.string().min(1, { message: 'Especialidade é obrigatória' }),
  });

  const methods = useForm<{
    specialist: string;
  }>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      specialist: '',
    },
  });
  const { control, watch } = methods;

  const specialist = watch('specialist');

  const getCalendlyEmbed = useCallback(() => {
    if (specialist === 'clinico-geral') {
      return (
        <InlineWidget
          url="https://calendly.com/telemedicinacg-partiu/30min?hide_event_type_details=1&hide_gdpr_banner=1"
          styles={{ height: '600px', width: '100%' }}
        />
      );
    }

    if (specialist === null) {
      return (
        <>
          <Label textAlign={'center'}>Selecione a especialidade para ver os horários disponíveis.</Label>
        </>
      );
    }

    return (
      <VStack width={'100%'} height={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
        <FaFrown size="50px" color={colors.primaryColor} />
        <Label textAlign={'center'}>
          Não há agenda para essa especialidade ainda. Por favor, selecione outra especialidade.
        </Label>
      </VStack>
    );
  }, [specialist]);

  useEffect(() => {
    const acceptedTerms = localStorage.getItem('acceptedTerms');
    const acceptedShareInformation = localStorage.getItem('acceptedShareInformation');

    if (!acceptedTerms || !acceptedShareInformation) {
      onOpen();
    }
  }, []);

  return (
    <MainTemplate>
      <Grid
        marginTop={{
          base: '20px',
          md: '50px',
        }}
        padding={{
          base: '20px',
          md: '20px',
        }}
        width={'100%'}
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
      >
        <Box
          display={{
            base: 'none',
            md: 'flex',
          }}
          height={'85vh'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Image width={'70%'} src="/assets/telemedicine.png" />
        </Box>
        <VStack  spacing={5} align={'flex-start'} width={'100%'}>
          <Heading paddingBottom={'10px'}>Telemedicina</Heading>
          <Text>
            Faça o agendamento da sua consulta de telemedicina. Selecione a data e o horário que deseja ser atendido.
          </Text>

          <VStack width={'100%'} spacing={5} alignItems={'start'}>
            <SelectInput
              options={[
                { value: 'clinico-geral', label: 'Clínico Geral' },
                { value: 'pediatra', label: 'Pediatra' },
                { value: 'dermatologista', label: 'Dermatologista' },
                { value: 'cardiologista', label: 'Cardiologista' },
              ]}
              placeholder="Selecione a especialidade"
              control={control}
              name="specialist"
              label="Especialidade *"
              autoWidth={false}
              multiple={false}
              native={false}
            />

            {getCalendlyEmbed()}
          </VStack>
        </VStack>
      </Grid>

      <TelemedicineAcceptModal isOpen={isOpen} onClose={onClose} />
    </MainTemplate>
  );
}
